"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Names = exports.Groups = void 0;
var Groups;
(function (Groups) {
    Groups["ProductSettings"] = "productSettings";
    Groups["ProductEdit"] = "productEdit";
    Groups["ContentPage"] = "contentPage";
})(Groups || (exports.Groups = Groups = {}));
var Names;
(function (Names) {
    Names["ActivePlayer"] = "activePlayer";
    Names["ErrorToActivePlayer"] = "ErrorToActivePlayer";
    Names["ActivePlayerConfirmed"] = "activePlayerConfirmed";
    Names["AgreeTermsToActivePlayer"] = "agreeTermsToActivePlayer";
    Names["DisagreeTermsToActivePlayer"] = "disagreeTermsToActivePlayer";
    Names["DeactivatePlayerConfirmation"] = "deactivatePlayerConfirmation";
    Names["DeactivatePlayer"] = "deactivatePlayer";
    Names["ErrorToDeactivatePlayer"] = "errorForDeactivatePlayer";
    Names["DismissPlayerModalConfirmation"] = "cancelPlayer";
    Names["ChangeTabConfiguration"] = "changeTab_configuration";
    Names["ShowPlayerActivateBanner"] = "showPlayerActivateBanner";
    Names["PlayerAlreadyActivated"] = "playerAlreadyActivated";
    Names["PlayerEnabledOnLoad"] = "playerEnabledOnLoad";
    Names["PlayerDisabledOnLoad"] = "playerDisabledOnLoad";
})(Names || (exports.Names = Names = {}));
